import { render, staticRenderFns } from "./ApplicationLanguageDropdown.vue?vue&type=template&id=54ded926&scoped=true"
import script from "./ApplicationLanguageDropdown.vue?vue&type=script&lang=js"
export * from "./ApplicationLanguageDropdown.vue?vue&type=script&lang=js"
import style0 from "./ApplicationLanguageDropdown.vue?vue&type=style&index=0&id=54ded926&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ded926",
  null
  
)

export default component.exports